module.exports = __webpack_public_path__ + "img/brand_66.20550578.png";